import { render, staticRenderFns } from "./AdminNaehrwerteLebensmittel.vue?vue&type=template&id=f23794ce&"
import script from "./AdminNaehrwerteLebensmittel.vue?vue&type=script&lang=js&"
export * from "./AdminNaehrwerteLebensmittel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports